<script setup>
import axios from 'axios';
import { BBadge, BNavItem } from 'bootstrap-vue-next';
import { computed, onMounted, onUnmounted, ref, watch } from 'vue';

import { useSubmissionsRefresh } from '~/common/useSubmissionsRefresh';
import { useVueData } from '~/common/useVueData';

const { pendingSubmissionsCount } = useVueData();
const { state } = useSubmissionsRefresh();

const count = ref(pendingSubmissionsCount);
const error = ref(false);

const fetchCount = async () => {
  try {
    const { data } = await axios.get('/api/v1/submissions/count');
    count.value = data.count;
    error.value = false;
  } catch {
    error.value = true;
  }
};

const ariaLabel = computed(() => (
  error.value ? 'Unable to load pending submissions count' : 'Pending submissions'
));

watch(() => state.version, fetchCount);

const onVisibilityChange = () => {
  if (document.visibilityState === 'visible') {
    fetchCount();
  }
};

onUnmounted(() => {
  document.removeEventListener('visibilitychange', onVisibilityChange);
});

onMounted(() => {
  document.addEventListener('visibilitychange', onVisibilityChange);
});
</script>

<template>
  <BNavItem
    :to="{ name: 'admin' }"
    :aria-label="ariaLabel"
  >
    <BBadge
      pill
      variant="secondary"
    >
      {{ error ? '?' : count }}
    </BBadge>
  </BNavItem>
</template>
